import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../codegen/Localize';
import { Telemetry } from '../../commonInfra/services/Telemetry';
import { TelemetryEvents } from '../../commonInfra/telemetryEvents/TelemetryEvents';
import { ChannelStyles } from '../styles/ChannelStyles';
import { HomeSeeAllClickEvent } from '../telemetry/HomeTelemetryEvents';
import { ChannelTypes } from '../types/ChannelTypes';

interface ChannelHeaderProps {
  readonly channelType: ChannelTypes;
  readonly title: string;
  readonly seeAllUrl?: string;
  readonly seeAllAltText?: string;
  readonly headerIconPath?: string;
  readonly headerIconNode?: React.ReactNode;
}

export class ChannelHeader extends React.PureComponent<ChannelHeaderProps> {

  private sendTelemetryEvent() {
    Telemetry.sendEvent<HomeSeeAllClickEvent>({
      type: TelemetryEvents.HomeSeeAllClick,
      channelType: this.props.channelType
    });
  }

  private mouseUpHandler(event: React.MouseEvent<HTMLAnchorElement>) {
    if(event.button !== 2) {
      this.sendTelemetryEvent();
    }
  }

  private keyPressHandler(event: React.KeyboardEvent<HTMLAnchorElement>) {
    if(event.nativeEvent.key === 'Enter') {
      this.sendTelemetryEvent();
    }
  }

  render() {
    const headerIcon: React.ReactNode = this.props.headerIconNode ?? (this.props.headerIconPath ?
      <img src={imgPath(this.props.headerIconPath)} className={ChannelStyles.headerIcon} alt=''/> : null);
    return (
      <header className={ChannelStyles.header}>
        <h2>{headerIcon}{this.props.title}</h2>
        {this.props.seeAllUrl &&
          <TextLinkWidget kind={TextLinkKind.Standalone}
            href={this.props.seeAllUrl}
            testId='overridden on next line'
            data-tb-test-id="channel-see-all-link"
            aria-label={this.props.seeAllAltText}
            onMouseUp={(e) => this.mouseUpHandler(e)}
            onKeyPress={(e) => this.keyPressHandler(e)}
          >
            {Messages.home_seeAll()}
          </TextLinkWidget>}
      </header>
    );
  }
}
